import { render } from "./Slider.vue?vue&type=template&id=29d13b08&scoped=true&ts=true"
import script from "./Slider.vue?vue&type=script&lang=ts"
export * from "./Slider.vue?vue&type=script&lang=ts"

import "./Slider.vue?vue&type=style&index=0&id=29d13b08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d13b08"]])

export default __exports__